module.exports = __webpack_public_path__ + "img/icon-4.ef79db60.svg";